import image from "src/assets/images/contactNetworkTab/defaultUserSvg.png"

export const defaultUser = image
